import { isValidElement, type ReactNode } from "react";

export function isValidReactNode(value: unknown): value is ReactNode {
  if (
    value === null ||
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean" ||
    typeof value === "undefined"
  ) {
    return true;
  }

  if (isValidElement(value)) {
    return true;
  }

  return false;
}
